import { Component, Input, OnInit } from '@angular/core';
import { IconName } from '@app/shared/utils/icon/icons';
import { IconComponent } from '../../utils/icon/icon.component';

@Component({
  selector: 'app-hyperlink',
  templateUrl: './hyperlink.component.html',
  styleUrls: ['./hyperlink.component.scss'],
  imports: [IconComponent],
})
export class HyperlinkComponent implements OnInit {
  @Input() download?: true | string;
  @Input() href?: string;
  @Input() hreflang?: string;
  @Input() ping?: string;
  @Input() rel?: string;
  @Input() target?: '_self' | '_blank' | '_parent' | '_top';
  @Input() type?: string;

  @Input() icon: IconName;

  ngOnInit(): void {
    if (this.target === '_blank') this.rel = 'noopener noreferrer';
  }
}
